'use client';

import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export interface LoginContextState {
  email: string;
  retryTime: number;
  setEmail: Dispatch<SetStateAction<string>>;
  setRetryTime: Dispatch<SetStateAction<number>>;
}

interface LoginContextProviderProps {
  children: ReactNode;
}

const LoginContext = createContext<LoginContextState | undefined>(undefined);

export const LoginContextProvider = ({
  children,
}: LoginContextProviderProps) => {
  const [email, setEmail] = useState('');
  const [retryTime, setRetryTime] = useState(0);

  return (
    <LoginContext.Provider
      value={{
        email,
        retryTime,
        setEmail,
        setRetryTime,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useLoginContext = () => {
  const context = useContext(LoginContext);

  if (!context) {
    throw new Error(
      'useLoginContext must be used within a LoginContextProvider',
    );
  }

  return context;
};
